// @flow
import React, { Fragment } from 'react';
import ContentText from 'Components/ContentText';
import DealerModel from 'Stores/DealerModel';
import { getGivenBackground } from 'Utils/getColor/index';

type Props = {
  dealer: DealerModel,
};

export default class DealerImprint extends React.Component<Props> {
  render() {
    const { dealer } = this.props;

    return (
      <ContentText background={getGivenBackground('white')}>
        <h4>VERANTWORTLICHE STELLE 2:</h4>
        <p>{dealer.name}</p>
        <p>
          {dealer.legalContact.street} {dealer.legalContact.houseNumber}
        </p>
        <p>
          D – {dealer.legalContact.postalCode} {dealer.legalContact.city}
        </p>
        <br />
        <p>
          Telefon: <a href={`tel:${dealer.legalContact.phone}`}>{dealer.legalContact.phone}</a>
        </p>
        <p>
          E-Mail: <a href={`mailto:${dealer.legalContact.email}`}>{dealer.legalContact.email}</a>
        </p>
        <br />
        <br />
        <p>Handelsregisternummer: {dealer.registrationNumber}</p>
        <p>Handelsgericht & Registergericht: {dealer.registrationCourt}</p>
        <p>Ust-ID-Nr.: {dealer.taxId}</p>
        {dealer.authorisedRepresentatives.length && (
          <p>Vertretungsberechtige(r): {dealer.authorisedRepresentatives.join(', ')}</p>
        )}
        {dealer.settings.imprint.text && (
          <Fragment>
            <br />
            <br />
            <div dangerouslySetInnerHTML={{ __html: dealer.settings.imprint.text }} />
          </Fragment>
        )}
      </ContentText>
    );
  }
}
